/* eslint-disable @typescript-eslint/naming-convention */
import React, { useRef } from 'react';

import { errorCatcherWrap } from '@search/error/src/catcher';
import {
    OfferQueryResponse
} from '@search/vtbeco-frontend-core/domain/offer/search/page/OfferQuery/__generated__/OfferQuery.graphql';

import { ClassifiedOfferGtmContext, createOfferGtm2Context } from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { ImageLazySrcSetProvide, useClImageLazySrcSetUrl } from '@search/vtbeco-frontend-core/domain/image/lazy/ImageLazySrcSet';
import { OfferCard2 } from '../../OfferCard/index2';

export const OfferPage = errorCatcherWrap(function OfferPage({
    data
}: {
    data?: OfferQueryResponse;
}) {
    const offerRef = useRef<Extract<OfferQueryResponse['offer'], {__typename: 'ProfOfferSnippet'}>>();
    const offer = (data?.offer.__typename === 'ProfOfferSnippet' ? data.offer : undefined) ?? offerRef.current;
    const isMyOffer = Boolean(data?.userDetails?.userId) && data?.userDetails?.userId === offer?.seller.placementUserId;

    offerRef.current = offer;

    const getUrl = useClImageLazySrcSetUrl({ baseUrl: offer?.gallery?.baseUrl });

    return (
        offer ?
            <ClassifiedOfferGtmContext.Provider value={createOfferGtm2Context({ place: 'card', offer })}>
                <ImageLazySrcSetProvide getUrl={getUrl}>
                    <OfferCard2
                        offer={offer}
                        userId={data?.userDetails?.userId ?? ''}
                        userPhone={data?.userDetails?.phone ?? ''}
                        shouldShowVasBlock={isMyOffer && offer.status?.vas?.length === 0}
                        isMyOffer={isMyOffer}
                    />
                </ImageLazySrcSetProvide>
            </ClassifiedOfferGtmContext.Provider> :
            null
    );
});
